export enum Mode {
	Edit = 'Edit',
	Add = 'Add',
}
